import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngTableComponent } from './kng-table.component';
import { KngTableService } from './kng-table.service';
import { KngButtonModule } from '../button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	declarations: [
		KngTableComponent
	],
	imports: [ CommonModule, KngButtonModule, MatCheckboxModule, MatSelectModule, FormsModule, MatTooltipModule ],
	exports: [
		KngTableComponent
	],
	providers: [
		KngTableService
	]
})
export class KngTableModule {}
